import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { SectionCard } from '../SectionCard/SectionCard';
export const GetPaymentMethodsCardTID = (parentTestId)=>getTestIds(parentTestId);
export function PaymentMethodsCard(param) {
    let { clientId: _clientId, paymentMethodsCount, onAddPaymentMethod } = param;
    const { PaymentMethodsCardTestIds: TID } = useMemo(()=>GetPaymentMethodsCardTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.summary.paymentMethods');
    if (paymentMethodsCount === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SectionCard, {
        bi: {
            name: 'client_detail_payment_methods_card'
        },
        testId: TID.Root(),
        title: texts.title(),
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_add_payment_method'
            },
            testId: TID.AddPaymentMethodButton(),
            skin: "primary",
            underline: "none",
            onClick: onAddPaymentMethod,
            children: texts.addPaymentMethod()
        }),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: TID.Empty(),
            skin: "secondary",
            children: texts.emptyMessage()
        })
    });
}
